module.exports = __webpack_public_path__ + "media/photo/Group 288-1d743878.png";